// Public GeoNames city centers, checked against the cached cities500 extract on 2026-09-09.
// Exact city + US state matches only. No customer or client addresses are included.
import type {CityReference} from './territory-model';
const rows: [string,string,string,number,number,string][] = [
 ['Little Rock','AR','Arkansas',34.74648,-92.28959,'4119403'],
 ['Poway','CA','California',32.96282,-117.03586,'5384690'],
 ['Santa Clarita','CA','California',34.39166,-118.54259,'5393049'],
 ['Bridgeport','CT','Connecticut',41.17923,-73.18945,'5282804'],
 ['Cape Coral','FL','Florida',26.56285,-81.94953,'4149962'],
 ['Atlanta','GA','Georgia',33.749,-84.38798,'4180439'],
 ['Louisville','KY','Kentucky',38.25424,-85.75941,'4299276'],
 ['Baltimore','MD','Maryland',39.29038,-76.61219,'4347778'],
 ['Kansas City','MO','Missouri',39.09973,-94.57857,'4393217'],
 ['Jackson','MS','Mississippi',32.29876,-90.18481,'4431410'],
 ['Greensboro','NC','North Carolina',36.07264,-79.79198,'4469146'],
 ['Winston-Salem','NC','North Carolina',36.09986,-80.24422,'4499612'],
 ['Cincinnati','OH','Ohio',39.12711,-84.51439,'4508722'],
 ['Beaverton','OR','Oregon',45.48706,-122.80371,'5713376'],
 ['Corvallis','OR','Oregon',44.56457,-123.26204,'5720727'],
 ['Tigard','OR','Oregon',45.43123,-122.77149,'5756758'],
 ['Philadelphia','PA','Pennsylvania',39.95238,-75.16362,'4560349'],
 ['Pittsburgh','PA','Pennsylvania',40.44062,-79.99589,'5206379'],
 ['Austin','TX','Texas',30.26715,-97.74306,'4671654'],
 ['Laredo','TX','Texas',27.50641,-99.50754,'4705349'],
 ['McAllen','TX','Texas',26.20341,-98.23001,'4709796'],
 ['Salt Lake City','UT','Utah',40.76078,-111.89105,'5780993'],
 ['Richmond','VA','Virginia',37.55376,-77.46026,'4781708'],
];
export const extraCities:Record<string,CityReference> = Object.fromEntries(rows.map(([place,code,state,latitude,longitude,id])=>[
 `${place}, ${code}`.toLowerCase(), {place,state,latitude,longitude,source:`https://www.geonames.org/${id}`,precision:'city center'},
]));
